<template>
    <div>
        <div class="cards-main__slider swiper">
            <div class="cards-main__wrapper swiper-wrapper" id="complexes-container">
                <div class="cards-main__slide swiper-slide"
                     v-for="property in properties"
                     :key="property.id"
                >
                    <catalog-property-card
                        :property="property"
                        :is-slider="true"
                    ></catalog-property-card>
                </div>
            </div>
            <div class="cards-main__pagination swiper-pagination"></div>
        </div>
        <button class="cards-main-button cards-main-button_prev _icon-slider_arr-left"></button>
        <button class="cards-main-button cards-main-button_next _icon-slider_arr-right"></button>
    </div>
</template>

<script>
import LoaderGray from "../loaders/LoaderGray.vue";

export default {
    name: "PropertySlider",
    components: {LoaderGray},
    props: {
        properties: {
            type: Array,
            default: () => []
        }
    }
}
</script>
